// API End points
export const serverIp = '';
export const GET_TOKEN = serverIp + '/token';
export const GET_USER_LINKS = serverIp + '/Api/UserLinks?';
export const GET_ROLE_DETAILS = serverIp + '/Account/GetRoleDetailsForEmail?email=';
export const GET_MOBILE_NUMBER = serverIp + '/Account/GetMobileNumberForEmail?email=';
export const UPDATE_MOBILE_NUMBER = serverIp + '/Account/ValidateAndUpdateMobileNumber?userId=';

export const GET_STATS = serverIp + '/Api/Stats?';
export const ASSIGNMENTS = serverIp + '/Api/Assignments';
export const INVOICES = serverIp + '/Api/Invoices';
export const VendorInvoices = serverIp + '/Api/VendorInvoices';
export const QUOTES = serverIp + '/Api/Quotes';
export const QUOTES_ESTIMATE = serverIp + '/Api/QuoteEstimator';
export const DOCUMENTS = serverIp + '/Api/Documents';


export const GET_COUNTRIES = serverIp + '/Api/Countries?';
export const GET_STATE = serverIp + '/Api/States?';
export const GET_QUOTE = serverIp + '/Api/Quotes/';
export const END_CLIENTS = serverIp + '/Api/EndClients';
export const GET_MANAGERS = serverIp + '/Api/Managers';
export const GET_WORKERS = serverIp + '/Api/Workers';
export const GET_MT_SERVICE = serverIp + '/Api/MyTalent';
export const GET_TEAMS = serverIp + '/Api/Teams';
export const VendorInvoicesLineItem = serverIp + '/Api/VendorInvoiceLineItems';
export const GET_CURRENCY = serverIp + '/Api/Currencies';
export const GET_PAYRATE = serverIp + '/Api/PayRateTypes';
export const GET_ALLOCATION = serverIp + '/Api/Allocations/';
export const ENTITY_API_URL = {COUNTRY: GET_COUNTRIES, STATE: GET_STATE};
export const SALES = serverIp + '/Api/UsEorQuotes';
export const GET_COUNTRYGUIDES = serverIp + '/Api/CountryGuides?';
export const GET_COUNTRYGUIDESDETAIL = serverIp + '/Api/CountryGuides/';
export const SALESSERV = serverIp + '/Api/Sales/';
export const USEORLINE = serverIp + '/Api/UsEorQuoteLineItems';
export const GET_WORKERSPROFILE = serverIp + '/Api/WorkerProfile';
export const GET_ENCRYPTPASSWORD_PHRASE = serverIp + '/Account/GetEncryptPasswordPhrase';
export const GET_ENCODE_PASSWORD = serverIp + '/Account/EncodePassword';